import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useMobileLayout from 'Hooks/useMobileLayout';
import { noop } from 'Helpers/PropTypes';
import {
  FDDialog, FDDialogActions, FDDialogContent, FDDialogTitle, FDPrimaryActionButton, FDTextInput,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

const NewMessageTemplateDialog = ({
  isOpen,
  closeModal,
  onSubmit,
}) => {
  const [templateName, setTemplateName] = useState('');
  const isMobile = useMobileLayout();

  // Submit / clear input state
  const handleOnTemplateSubmit = () => {
    onSubmit(templateName);
    setTemplateName(''); // <--- Clears input state
  };

  return (
    <FDDialog
      dialogWidth={'sm'}
      fullScreen={isMobile}
      onClose={closeModal}
      open={isOpen}
      {...dataAttrs('new-message-template-dialog')}
    >
      <FDDialogTitle value={'New template'} />
      <FDDialogContent>
        <FDTextInput
          onChange={(evt) => setTemplateName(evt.target.value)}
          {...dataAttrs('new-message-template-dialog-name-input')}
          fullWidth
          label={'Template Name'}
          value={templateName}
        />
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          onClick={handleOnTemplateSubmit}
          disabled={!templateName.length}
          test={'new-message-template-dialog-save-button'}
          label={'Save Template'}
        />
      </FDDialogActions>
    </FDDialog>
  );
};

NewMessageTemplateDialog.defaultProps = {
  onSubmit: noop,
};

NewMessageTemplateDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
};

export default NewMessageTemplateDialog;
